import React, { createContext, FC, memo } from "react";

import { FeatureCardProps } from "../../types";

export const FeatureCardContext = createContext<FeatureCardProps>(null);

export const FeatureCardProvider: FC<{ settings: FeatureCardProps }> = memo(({ settings, children }) => (
  <FeatureCardContext.Provider value={settings}>{children}</FeatureCardContext.Provider>
));
